import { object, string } from 'yup';

export const InviteMemberFormSchema = object().shape({
  full_name: string()
    .matches(/^\D*$/, 'Please enter a valid full name.')
    .required('Please enter full name.'),
  email: string().email('Please provide a valid email').required('Please enter a email'),
});
